import React from "react";
import { motion } from "framer-motion";

const EXEStats = () => {
  const stats = [
    {
      number: "200K",
      label: "Total Prize Pool",
      description: "LKR in cash prizes and industry opportunities",
      color: "text-exe-text-accent"
    },
    {
      number: "300+",
      label: "Delegates",
      description: "Developers from schools, and universities",
      color: "text-exe-text-accent"
    },
    {
      number: "15+",
      label: "Industry Partners",
      description: "Leading game companies and tech organizations",
      color: "text-exe-text-accent"
    },
    {
      number: "2",
      label: "Competition Categories",
      description: "Schools & Universities",
      color: "text-exe-text-accent"
    },
    {
      number: "300+",
      label: "Development Hours",
      description: "Intense competition period for creating games",
      color: "text-exe-text-accent"
    },
    {
      number: "3+",
      label: "Expert Judges",
      description: "Industry professionals evaluating submissions",
      color: "text-exe-text-accent"
    }
  ];

  return (
    <section className="exe-section">
      <div className="exe-container">
        <div className="max-w-6xl mx-auto">
          
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="exe-title text-exe-text-accent mb-6">
              Competition Overview
            </h2>
            <div className="h-1 w-24 bg-exe-gradient-primary mx-auto mb-8"></div>
            <p className="exe-text text-xl max-w-3xl mx-auto">
              EXE brings together the best of Sri Lankan game development talent 
              in an unprecedented competition experience
            </p>
          </motion.div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="exe-glass-card p-8 text-center relative overflow-hidden group"
              >
                {/* Background effect */}
                <div className="absolute inset-0 bg-exe-primary opacity-0 group-hover:opacity-5 transition-opacity duration-150"></div>
                
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.4, delay: index * 0.1 + 0.3 }}
                  viewport={{ once: true }}
                  className="relative z-10"
                >
                  <div className={`font-game text-4xl lg:text-5xl font-bold mb-3 ${stat.color}`}>
                    {stat.number}
                  </div>
                  <h3 className="exe-heading text-lg mb-3 text-exe-text-primary">
                    {stat.label}
                  </h3>
                  <p className="exe-text text-sm">
                    {stat.description}
                  </p>
                </motion.div>

                {/* Decorative elements */}
                <div className="absolute top-2 right-2 w-16 h-16 bg-exe-circuit-pattern opacity-5"></div>
                <div className="absolute bottom-2 left-2 w-8 h-8 border border-exe-border-secondary rounded-full opacity-20"></div>
              </motion.div>
            ))}
          </div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
            className="exe-card p-8 text-center"
          >
            <h3 className="exe-heading text-exe-text-accent mb-6">
              Why Participate in EXE?
            </h3>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div>
                <h4 className="font-semibold text-exe-text-primary mb-3">Career Opportunities</h4>
                <p className="exe-text text-sm">
                  Connect directly with hiring managers from top game studios and tech companies
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-exe-text-primary mb-3">Skill Development</h4>
                <p className="exe-text text-sm">
                  Learn new technologies, frameworks, and industry best practices from mentors
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-exe-text-primary mb-3">Portfolio Building</h4>
                <p className="exe-text text-sm">
                  Create impressive projects that showcase your abilities to future employers
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default EXEStats;
